var render = function render(){var _vm=this,_c=_vm._self._c;return _c('footer',{staticClass:"footer"},[_vm._t("bg"),_vm._t("ba-copy")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }